import React from "react";

const Footer = () => {
  return (
    <>
      <style>{`
        .font-footer {
          background: #222;
          color: white;
          text-align: center;
          padding: 10px;
        }
      `}</style>

      <div className="font-footer">
          © 2026 Nano Cloud Technology, School Management System All Rights Reserved.
      </div>
    </>
  );
};

export default Footer;